import * as React from 'react';

import { ResponsiveSlider } from '../../components/ResponsiveSlider';
import { SliderCounter } from '../../components/SliderCounter';
import { useResponsiveSliderSize } from './hooks';

export interface IResponsiveSliderContainerProps<TItem> {
  slides: TItem[];
  renderSlide: (item: TItem, index: number) => React.ReactNode;
  padding?: number;
}

export function ResponsiveSliderContainer<TItem>({
  slides,
  renderSlide,
  padding = 0,
}: IResponsiveSliderContainerProps<TItem>) {
  const { sliderRef, dotsRef, size } = useResponsiveSliderSize({ padding });

  const renderedSlides = slides.map((slide, index) => {
    return renderSlide(slide, index);
  });

  return (
    <div ref={sliderRef} style={{ height: '100%' }}>
      <ResponsiveSlider
        slides={renderedSlides}
        size={size}
        padding={padding}
        renderDots={({ currentSlide, totalSlides }) => (
          <div ref={dotsRef}>
            <SliderCounter current={currentSlide + 1} total={totalSlides} />
          </div>
        )}
      />
    </div>
  );
}
